import loader from './loader_black.svg';
import React from 'react';
import './loader.scss';
export default function Loader(props) {
  return (
    <div style={{height: props.height ? props.height+'px' : '500px'}}>
    {/* <img src={loader} className="loader" alt="loader" /> */}
    </div>
  );
}